import dayjs from "dayjs";
import React from "react";
import { FaArrowLeft, FaFileAlt, FaUser } from "react-icons/fa";

const PaymentUserProductDetails = ({ setshowdetail, data }) => {
  return (
    <div className="p-8">
      {/* Back to List Button */}
      <div className="mb-4">
        <button
          onClick={() => setshowdetail(false)}
          className="flex items-center bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition duration-300 font-semibold shadow-lg"
        >
          <FaArrowLeft className="mr-2" /> Back to List
        </button>
      </div>

      {/* Header Section */}
      <div className="mb-8 p-8 rounded-xl bg-gradient-to-r from-green-600 to-teal-600 text-white shadow-2xl">
        <h3 className="text-2xl font-semibold flex items-center mb-4 text-gray-100">
          <FaUser className="mr-3" /> User Details
        </h3>
        <p className="text-lg">
          <span className="font-semibold text-gray-200">User Name:</span>
          <span className="ml-3 capitalize">{data?.userId?.name}</span>
        </p>
        <p className="text-lg">
          <span className="font-semibold text-gray-200">Payment Date:</span>
          <span className="ml-3">
            {dayjs(data?.createdAt).format("DD MMM YYYY")}
          </span>
        </p>
      </div>

      {/* User and Product Details */}
      <div className="flex flex-col lg:flex-row gap-8 mb-6">
        {/* User Information */}
        <div className="flex-1 p-6 rounded-lg bg-white shadow-lg hover:shadow-2xl transition-shadow duration-300">
          <h4 className="text-xl font-semibold mb-4 flex items-center text-blue-500">
            <FaUser className="mr-3" /> User Information
          </h4>
          <div className="space-y-3">
            <div className="flex justify-between">
              <span className="text-gray-600 font-semibold">Name:</span>
              <span className="font-medium text-gray-800">
                {data?.userId?.name}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600 font-semibold">Email:</span>
              <span className="font-medium text-gray-800">
                {data?.userId?.email}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600 font-semibold">Mobile:</span>
              <span className="font-medium text-gray-800">
                {data?.userId?.mobile}
              </span>
            </div>
          </div>
        </div>

        {/* Product Information */}
        <div className="flex-1 p-6 rounded-lg bg-white shadow-lg hover:shadow-2xl transition-shadow duration-300">
          <h4 className="text-xl font-semibold mb-4 flex items-center text-green-500">
            <FaFileAlt className="mr-3" /> Product Information
          </h4>
          <div className="mb-6 flex justify-end">
            <img
              src={`data:${data?.productId?.image?.contentType};base64,${data?.productId?.image?.data}`}
              alt={data?.productId?.name}
              className="w-56 h-56 object-cover rounded-lg shadow-lg"
            />
          </div>
          <div className="space-y-3">
            <div className="flex justify-between">
              <span className="text-gray-600 font-semibold">Product Name:</span>
              <span className="font-medium text-gray-800">
                {data?.productId?.name}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600 font-semibold">Price:</span>
              <span className="font-medium text-gray-800">
                {data?.productId?.price} {data?.productId?.priceUnit}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600 font-semibold">Stock:</span>
              <span className="font-medium text-gray-800">
                {data?.productId?.stock} Units
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600 font-semibold">Category:</span>
              <span className="font-medium text-gray-800">
                {data?.productId?.category?.name}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600 font-semibold">Sub Category:</span>
              <span className="font-medium text-gray-800">
                {data?.productId?.subcategory?.name}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600 font-semibold">
                Delivery Preference:
              </span>
              <span className="font-medium text-gray-800">
                {data?.productId?.deliveryPreference?.duration}{" "}
                {data?.productId?.deliveryPreference?.unit}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Combined Details */}
      <div
        className={`flex flex-col ${
          data?.refundId ? "md:flex-row md:space-x-6" : ""
        }`}
      >
        {/* Buying Time Details */}
        <div className="p-6 rounded-lg bg-white shadow-lg hover:shadow-2xl transition-shadow duration-300 mb-6 flex-1">
          <h4 className="text-xl font-semibold mb-4 flex items-center text-red-500">
            <FaFileAlt className="mr-3" /> Buying Details
          </h4>
          <div className="space-y-3">
            <div className="flex justify-between">
              <span className="text-gray-600 font-semibold">Price:</span>
              <span className="font-medium text-gray-800">{data?.price}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600 font-semibold">Quantity:</span>
              <span className="font-medium text-gray-800">
                {data?.quantity}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600 font-semibold">
                Tracking Status:
              </span>
              <span className="font-medium text-gray-800">
                {data?.ordertrackingId?.statusUpdates?.slice(-1)?.[0]?.status ||
                  "Not Available"}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600 font-semibold">
                Revenue (Excluding GST):
              </span>
              <span className="font-medium text-gray-800">
                {data?.subtotalwithoutgst}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600 font-semibold">
                Total (Including GST):
              </span>
              <span className="font-medium text-gray-800">
                {data?.subtotalwithgst}
              </span>
            </div>
          </div>
        </div>

        {/* Refund Details */}
        {data?.refundId && (
          <div className="p-6 rounded-lg bg-white shadow-lg hover:shadow-2xl transition-shadow duration-300 mb-6 flex-1">
            <h4 className="text-xl font-semibold mb-4 flex items-center text-purple-500">
              <FaFileAlt className="mr-3" /> Refund Details
            </h4>
            <div className="space-y-3">
              <div className="flex justify-between">
                <span className="text-gray-600 font-semibold">
                  Refund Type:
                </span>
                <span className="font-medium text-gray-800">
                  {data?.refundId?.refundType}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600 font-semibold">
                  Refund Amount:
                </span>
                <span className="font-medium text-gray-800">
                  {data?.refundId?.refundAmount}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600 font-semibold">Status:</span>
                <span className="font-medium text-gray-800">
                  {data?.refundId?.status}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600 font-semibold">Reason:</span>
                <span className="font-medium text-gray-800">
                  {data?.refundId?.reason}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600 font-semibold">
                  Initiated On:
                </span>
                <span className="font-medium text-gray-800">
                  {dayjs(data?.refundId?.createdAt).format("DD MMM YYYY")}
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentUserProductDetails;
